// Buttons here read as sentences ("Ask the client"), so they keep their case.
export const PLAIN_BUTTONS = { "& .MuiButton-root": { textTransform: "none" } } as const;
